(function () {
  'use strict';

  var GEO_ENDPOINT = 'https://geo.shopaleena.com/api/geo';
  var STORAGE_KEY = 'shopaleena_geo';
  var MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 hours

  function getCachedGeo() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var cached = JSON.parse(raw);
      if (!cached || !cached.timestamp) return null;

      var age = Date.now() - cached.timestamp;
      if (age > MAX_AGE_MS) return null;

      return cached.data;
    } catch (e) {
      return null;
    }
  }

  function cacheGeo(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        data: data
      }));
    } catch (e) {
      // localStorage unavailable — ignore
    }
  }

  function fetchGeo() {
    return fetch(GEO_ENDPOINT, { method: 'GET' })
      .then(function (res) {
        if (!res.ok) throw new Error('Geo request failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        cacheGeo(data);
        return data;
      });
  }

  function getGeo() {
    var cached = getCachedGeo();
    if (cached) {
      return Promise.resolve(cached);
    }
    return fetchGeo().catch(function (err) {
      console.warn('[geo] lookup failed:', err);
      return null;
    });
  }

  window.ShopaleenaGeo = { get: getGeo };

  getGeo().then(function (geo) {
    if (!geo) return;
    document.dispatchEvent(new CustomEvent('geo:ready', { detail: geo }));
  });
})();
